export enum EUserRoles {
    ADMIN = 1,
    MANAGER = 2,
    SENIOR = 3,
    CLIENT = 4,
}
